require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-yarrabend-launch.json") })
        }
      }, "path---news-yarrabend-launch");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-yarrabend-launch!./.cache/json/news-yarrabend-launch.json
// module id = 870
// module chunks = 231608221292675